import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Row,
  Col,
  CardHeader,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Breadcrumb,
  BreadcrumbItem,
  ButtonGroup,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { getAuthToken, isAuthenticated } from '../../auth/tokenvalidation';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './HpsView.css';
import ProductHydro from './component/ProductHydro';
import HydrocarbonCondensat from './component/HydrocarbonCondensat';

const TABS = [
  {
    id: 'product-hydro',
    label: 'Product Hydro',
    icon: 'ri-drop-line',
    component: ProductHydro,
  },
  {
    id: 'hydrocarbon-condensat',
    label: 'Hydrocarbon & Condensate',
    icon: 'ri-test-tube-line',
    component: HydrocarbonCondensat,
  },
];

const InvitationEvaluationView = () => {
  const [activeTab, setActiveTab] = useState('product-hydro');
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const { user } = useSelector(state => state.Login);
  const token = getAuthToken();
  const userRoles = user?.role?.split(',').map(r => r.trim()) || [];
  const hasKPI = userRoles.includes('KPI');
  const hasPPN = userRoles.includes('PPN');
  const onlyKPI = hasKPI && !hasPPN;
  const onlyPPN = !hasKPI && hasPPN;
  const showBoth = (hasKPI && hasPPN) || (!hasKPI && !hasPPN);
  const showProductHydro = onlyPPN || showBoth;
  const showHydroCondensate = onlyKPI || showBoth;

  const visibleTabs = TABS.filter(tab => {
    if (tab.id === 'product-hydro') return showProductHydro;
    if (tab.id === 'hydrocarbon-condensat') return showHydroCondensate;
    return true;
  });

  // Authentication validation
  useEffect(() => {
    if (!token) {
      toast.error('Authentication token not found. Please login again.');
      return;
    }
    if (!isAuthenticated()) {
      toast.error('Please login to access this page.');
      return;
    }
  }, [token]);

  useEffect(() => {
    const defaultTab = onlyKPI ? 'hydrocarbon-condensat' : 'product-hydro';
    if (!visibleTabs.find(t => t.id === activeTab)) {
      setActiveTab(visibleTabs[0]?.id || defaultTab);
    }
    if (onlyKPI) {
      setActiveTab('hydrocarbon-condensat');
    }
  }, [onlyKPI, onlyPPN, activeTab, visibleTabs]);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} />
      <div className='email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
        <div className='email-content minimal-border'>
          <div className='p-4 pb-0'>
            <div className='border-bottom border-bottom-dashed'>
              <Row className='mt-n2 mb-1 mb-sm-0'>
                <div className='col-sm order-3 order-sm-2'>
                  <div className='hstack gap-sm-1 align-items-center flex-wrap email-topbar-link'>
                    <h5 className='card-title mb-0 flex-grow-1 '>
                      <Breadcrumb listClassName='p-3 py-2 bg-light'>
                        <BreadcrumbItem>
                          {' '}
                          <Link to='#'> Home </Link>{' '}
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                          {' '}
                          <Link to='#'> Invitation Evaluation </Link>{' '}
                        </BreadcrumbItem>
                        <BreadcrumbItem active> View </BreadcrumbItem>
                      </Breadcrumb>
                    </h5>
                  </div>
                </div>
                <div className='col-auto order-2 order-sm-3 '>
                  <div className='d-flex gap-sm-1 email-topbar-link '>
                    <button
                      type='button'
                      className='btn btn-ghost-secondary material-shadow-none btn-icon btn-sm fs-16'
                      onClick={handleRefresh}
                    >
                      <i className='ri-refresh-line align-bottom'></i>
                    </button>
                  </div>
                </div>
              </Row>

              <Row className='row align-items-end mt-1 mb-1'>
                <Col xs={12}>
                  <CardHeader className='border-0'>
                    <div className='d-flex align-items-center flex-wrap'>
                      <h5 className='card-title mb-0 flex-grow-1 text-uppercase'>
                        Invitation Evaluation
                      </h5>

                      <div className='flex-shrink-0'>
                        <div className='d-flex gap-2 flex-wrap'>
                          <ButtonGroup>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                tag='button'
                                className='btn btn-light btn-label right ms-auto nexttab btn-sm'
                              >
                                Export{' '}
                                <i className=' ri-file-list-2-line label-icon align-middle fs-16 ms-2'></i>{' '}
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem>Export to Excel</DropdownItem>
                                <DropdownItem>Export to CSV</DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </ButtonGroup>
                        </div>
                      </div>
                    </div>
                  </CardHeader>
                </Col>
              </Row>
            </div>

            <div className='message-list-content mx-n4 px-4 message-list-scroll'>
              <Nav tabs className='nav-tabs-custom nav-primary mt-3 mb-0'>
                {visibleTabs.map(tab => (
                  <NavItem key={tab.id}>
                    <NavLink
                      className={classnames('cursor-pointer', {
                        active: activeTab === tab.id,
                      })}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      <i className={`${tab.icon} align-middle me-1`}></i>
                      <span className='fw-semibold'>{tab.label}</span>
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              <TabContent activeTab={activeTab} className='pt-3'>
                {visibleTabs.map(tab => {
                  const TabComponent = tab.component;
                  return (
                    <TabPane key={tab.id} tabId={tab.id}>
                      <TabComponent refreshTrigger={refreshTrigger} />
                    </TabPane>
                  );
                })}
              </TabContent>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer closeButton={false} limit={1} />
    </React.Fragment>
  );
};

export default React.memo(InvitationEvaluationView);
